import React, { Component, lazy } from 'react';
import {Provider} from 'react-redux';
import 'antd/dist/antd.css'; 
import './App.css';
import './Responsive.css';
import { BrowserRouter as Router, Switch, Redirect, Route, withRouter } from 'react-router-dom';
import store, {CART_COUNT_UPDATE} from './utils/store';

import Signin from './components/Signin';
import Products from './components/Products';
import Details from './components/Details';
import CmsStaticPage from './components/pages/CmsStaticPage';
import Contactus from './components/pages/Contactus';
import Brands from './components/Brands';
import Compare from './components/Compare';

import Account from './components/account/Account';
import Address from './components/account/Address';
import ChangePassword from './components/account/ChangePassword';
import Wishlist from './components/account/Wishlist';
import Cart from './components/account/Cart';
import Checkout from './components/account/Checkout';
import Reviews from './components/account/Reviews';
import Orders from './components/account/Orders';
import OrderConfirmation from './components/account/OrderConfirmation';
import OrdersTrack from './components/account/OrdersTrack';


import PrivateRoute from './components/route/PrivateRoute';
import PublicRoute from './components/route/PublicRoute';

import AuthorizedLayout from './components/layouts/authorized-layout';
import UnauthorizedLayout from './components/layouts/unauthorized-layout';

import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import ProfileCompletionNotice from './components/account/ProfileCompletionNotice';

const Home = lazy(() => import('./components/Home'));

const AboutusPage = (props) => <CmsStaticPage {...props} slug="aboutus" title="About Us" />;
const DeliveryinfoPage = (props) => <CmsStaticPage {...props} slug="deliveryinfo" title="Shipping and Delivery Policy" />;
const PrivacypolicyPage = (props) => <CmsStaticPage {...props} slug="privacypolicy" title="Privacy Policy" />;
const RefundpolicyPage = (props) => <CmsStaticPage {...props} slug="refundpolicy" title="Returns, Refunds, Cancellation and Exchange Policy" />;
const TermsPage = (props) => <CmsStaticPage {...props} slug="terms" title="Terms and Conditions" />;

class App extends Component {


  constructor(props) {
      super(props);
      this.state = {
      }   
  }

  ScrollToTop = withRouter(({ location }) => {
    React.useEffect(() => {
      window.scrollTo(0, 0);
    }, [location.pathname, location.search, location.hash]);

    return null;
  });

  render() { 
    return (
      <div className="byosMainBox">
        <Provider store={store}>
          <Router>
                <this.ScrollToTop />
                <ProfileCompletionNotice />
                <Switch>

                        <PublicRoute component={Home} path="/" exact />
                        <PublicRoute restricted={false} component={Products} path="/category/:name" exact />
                        <PublicRoute restricted={false} component={Products} path="/products/category/:name" exact />
                        <PublicRoute restricted={false} component={Products} path="/products/:type/:id/:name" exact />
                        <PublicRoute restricted={false} component={Details} path="/details/:slug" exact />
                        <PublicRoute restricted={false} component={Details} path="/details/:id/:name" exact />
                        <PublicRoute restricted={false} component={Details} path="/product/:slug" exact />
                        <PublicRoute restricted={false} component={AboutusPage} path="/aboutus" exact />
                        <PublicRoute restricted={false} component={DeliveryinfoPage} path="/deliveryinfo" exact />
                        <PublicRoute restricted={false} component={PrivacypolicyPage} path="/privacypolicy" exact />
                        <PublicRoute restricted={false} component={RefundpolicyPage} path="/refundpolicy" exact />
                        <PublicRoute restricted={false} component={TermsPage} path="/terms" exact />

                        <PublicRoute restricted={false} component={Contactus} path="/contactus" exact />
                        <PublicRoute restricted={false} component={Brands} path="/brands" exact />
                        <PublicRoute restricted={false} component={Compare} path="/compare" exact />
                        <PublicRoute component={Signin} path="/signin" exact />

                        <PublicRoute restricted={false} exact component={Cart} path="/cart" />
                        <PrivateRoute exact component={Checkout} path="/checkout" />
                        <PrivateRoute exact component={OrderConfirmation} path="/orderconfirmation" />
                        <PrivateRoute exact component={OrderConfirmation} path="/orderpreview" />
                        

                        <PrivateRoute exact component={Account} path="/account" />
                        <PrivateRoute exact component={Address} path="/address" />
                        <PrivateRoute exact component={ChangePassword} path="/password" />
                        <PrivateRoute exact component={Wishlist} path="/wishlist" />
                        <PrivateRoute exact component={Reviews} path="/reviews" />
                        <PrivateRoute exact component={Orders} path="/orders" />
                        <PrivateRoute exact component={OrdersTrack} path="/trackorders" />

                    {/* <Route exact path="/" component={Home}/>
                    <Route exact path="/signin" component={Signin}/> */}
                    {/* <PrivateRoute path="/profile" component={AuthorizedLayout} /> */}
                    {/* <Redirect to="/signin" /> */}
                    
                </Switch>
                <a
                  className="ps-whatsapp-chat"
                  href="https://wa.me/918946025885?text=Hello%20Nature%20Way%2C%20I%20would%20like%20to%20know%20more%20about%20your%20products%20and%20offers."
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat with Nature Way on WhatsApp"
                  title="Chat with us on WhatsApp"
                >
                  <i className="fa fa-whatsapp" aria-hidden="true"></i>
                </a>
          </Router>
          </Provider>
      </div>
    );
  }
}

export default App;
